import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  TextField,
} from '@mui/material';
import { useCallback } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DraggableDialog } from '~/components/Dialogs/components/DraggableDialog';
import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { LegacyFAIcon, LegacyFAIcons } from '~/legacy-components/LegacyFAIcon';

import { useLegacyChangePassword } from './useLegacyChangePassword';
import { useSxStyles } from './useStyles';

type Props = {
  resetDialog: () => void;
};

export const LegacyChangePassword = ({ resetDialog }: Props) => {
  const {
    onSave,
    handleClose,
    open,
    formMethods: { control },
  } = useLegacyChangePassword();
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const handleDialogClose = useCallback(() => {
    handleClose();
    resetDialog();
  }, [handleClose, resetDialog]);

  return (
    <DraggableDialog open={open} onClose={handleDialogClose}>
      <SolaForceDialogTitle
        icon={<LegacyFAIcon FAIcon={LegacyFAIcons.Key} />}
        onClose={handleDialogClose}
      >
        {t('laChangePassword')}
      </SolaForceDialogTitle>
      <DialogContent dividers={true}>
        <Box component={'form'} sx={sxStyles.fieldLayout} autoComplete={'off'}>
          <Controller
            control={control}
            name={'currentPassword'}
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  {...field}
                  required={true}
                  type={'password'}
                  label={t('laCurPass')}
                  InputLabelProps={{ shrink: true }}
                  error={!!error}
                  helperText={error?.message}
                />
              );
            }}
          />
          <Controller
            control={control}
            name={'newPassword'}
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  {...field}
                  required={true}
                  type={'password'}
                  label={t('laNewPass')}
                  InputLabelProps={{ shrink: true }}
                  placeholder={t('la6Chara')}
                  error={!!error}
                  helperText={error?.message}
                />
              );
            }}
          />
          <Controller
            control={control}
            name={'confirmPassword'}
            render={({ field, fieldState: { error } }) => {
              return (
                <TextField
                  {...field}
                  required={true}
                  type={'password'}
                  label={t('laConfirmPass')}
                  InputLabelProps={{ shrink: true }}
                  placeholder={t('la6Chara')}
                  error={!!error}
                  helperText={error?.message}
                />
              );
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onSave}>{t('save')}</Button>
      </DialogActions>
    </DraggableDialog>
  );
};
